import { render, staticRenderFns } from "./PayersSortDropdown.vue?vue&type=template&id=cc371ef4&scoped=true"
import script from "./PayersSortDropdown.vue?vue&type=script&lang=js"
export * from "./PayersSortDropdown.vue?vue&type=script&lang=js"
import style0 from "./PayersSortDropdown.vue?vue&type=style&index=0&id=cc371ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc371ef4",
  null
  
)

export default component.exports